import { ContentType } from '@trellis/api'
import type { SendReminderEmailDto, SendReminderEmailResponseDto } from '@trellis/api'
import type { RequestResult } from '@trellis/shared'

import { apiClient } from '@/lib/api-client'
import { request } from '@/lib/request'

export interface SendInvoiceBody {
  to?: string
  subject?: string
  message?: string
  force?: boolean
}

export interface SendInvoiceResult {
  sentAt: string
}

export const sendInvoice = (
  id: string,
  body: SendInvoiceBody,
): Promise<RequestResult<SendInvoiceResult>> =>
  request<SendInvoiceResult>(() =>
    apiClient.api.request({
      path: `/api/invoices/${id}/send`,
      method: 'POST',
      body,
      type: ContentType.Json,
      format: 'json',
    }),
  )

/** Sends the standard reminder now; 429 `REMINDER_RATE_LIMITED` within 24 hours of any. */
export const sendReminderEmail = (id: string, body: SendReminderEmailDto) =>
  request<SendReminderEmailResponseDto>(() =>
    apiClient.api.invoicesControllerSendReminderEmail({ id }, body),
  )
